import axios from 'axios'
import get from 'lodash/get'
import app from './main'
import router from "@/router/index"

const baseURL = process.env.VUE_APP_API_URL
  ? process.env.VUE_APP_API_URL
  : process.env.VUE_APP_BASE_URL
const headers = {
  'Content-Type': 'application/json'
}

const instance = axios.create({
  baseURL,
  headers,
  withCredentials: true
})

instance.interceptors.request.use((config) => {
  return config
})

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // BFF APIのみcatchする
    if (error.response) {
      if (process.env.VUE_APP_API_DOMAIN + "/" === error.response.config.baseURL) {
        console.log("error.response >>> ", error.response);
        // APIのエラー結果を入れる前に、残っているエラー情報を削除する
        Vue.prototype.$error.reset();
        // 失敗時のレスポンス情報をstore(localstorage)に保存
        Vue.prototype.$error.code = error.response.status;
        Vue.prototype.$error.url = `[${error.response.config.method}] ${error.response.config.url}`;
        Vue.prototype.$error.data = error.response.data;
      }

      const statuscode = error.response.status;
      if (
        statuscode === 401 &&
        error.response.config.url != "/session-time-out"
      ) {
        app.$auth.user = null;
        app.$auth.loggedIn = false;
        app.$auth.remove();
        // ＣＲＭ汎用対応
        // topのセッションタイムアウトエラーページへ遷移
        location.href = process.env.VUE_APP_TOP_DOMAIN + "/session-time-out";
      }
      if (statuscode === 403) {
        app.$router.push('/pages/no-valid-plan-menu')
        return
      }
      try {
        let message = get(error, 'response.data.error.message')
        if (message && typeof message === 'string') {
          message = message
            .substring(message.indexOf(':') + 1)
            .trim()
            .substring(1)
          message = JSON.parse(message.substring(0, message.length - 1))
          return Promise.reject({
            statuscode,
            data: message
          })
        }
      } catch (e) {
        return Promise.reject({
          ...error.response,
          isError: true,
          statuscode,
          data: get(error, 'response.data')
        })
      }
      return Promise.reject({
        ...error.response,
        isError: true,
        statuscode,
        data: get(error, 'response.data')
      })
    } else {
      return false;
    }
  }
)

export default instance
